import ApiService from './ApiService'
import { API_BASE_URL } from 'redux/constants'
import apiFetch from 'utils/apiFetch'

// Real backend login implementation
export async function apiSignIn (data) {
    // Dummy login for employees - accept any credentials
    const userName = (data.userName || data.email || data.Email || '').toLowerCase()
    const password = (data.password || data.Password || '').toLowerCase()

    const isEmployeeLogin =
        userName.includes('employee') ||
        userName.includes('emp') ||
        password === 'employee' ||
        password === 'emp' ||
        data.isEmployee === true

    if (isEmployeeLogin) {
        return {
            status: true,
            message: 'Login successful',
            token: 'employee-dummy-token-' + Date.now(),
            data1: {
                id: 'emp-' + Date.now(),
                firstName: 'Employee',
                lastName: 'User',
                email: userName || 'employee@example.com',
                userType: 'employee',
                image: null
            },
            data: [
                {
                    key: 'employeeDashboard',
                    path: '/employee-dashboard',
                    title: 'Dashboard',
                    icon: 'home',
                    subMenu: []
                }
            ]
        }
    }

    const payload = {
        email: data.userName || data.email || data.Email,
        password: data.password || data.Password,
        isBioApp: false
    }

    const response = await apiFetch(API_BASE_URL + 'Account/Login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })

    return response.json()
}

export async function apiValidateOTP (data) {
    const payload = {
        email: data.email,
        otp: data.otp
    }

    const response = await apiFetch(API_BASE_URL + 'Account/ValidateOTP', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })

    return response.json()
}

export async function apiSignUp (data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data
    })
}

export async function apiSignOut (data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
}

export async function apiForgotPassword(emailData) {
    const email = encodeURIComponent(emailData?.email || '')
    const response = await apiFetch(API_BASE_URL + `Account/ForgetPassword?email=${email}`, {
        method: 'POST',
        headers: {
            accept: 'text/plain'
        }
    })
    return response.json()
}

export async function apiResetPassword (data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data
    })
}

export async function apiChangePassword (data) {
    const payload = {
        email: data.email,
        currentPassword: data.currentPassword,
        newPassword: data.newPassword
    }

    const response = await apiFetch(API_BASE_URL + 'Account/ChangePassword', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            accept: 'text/plain'
        },
        body: JSON.stringify(payload)
    })

    return response.json()
}
